import { ClerkProvider, useAuth } from '@clerk/tanstack-react-start';
import { ConvexProviderWithClerk } from 'convex/react-clerk';
import { ConvexReactClient } from 'convex/react';
import type { ReactNode } from 'react';

type AppAuthProviderProps = {
  client: ConvexReactClient;
  children: ReactNode;
};

export function AppAuthProvider({ client, children }: AppAuthProviderProps) {
  const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  if (!publishableKey) {
    throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable');
  }

  return (
    <ClerkProvider publishableKey={publishableKey} signInUrl="/login" signUpUrl="/signup">
      <ConvexProviderWithClerk client={client} useAuth={useAuth}>
        {children}
      </ConvexProviderWithClerk>
    </ClerkProvider>
  );
}
